import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { PrazoPagamentoItens } from '../../models/prazos-pagamento/prazo-pagamento-itens';

@Injectable({
  providedIn: 'root'
})

export class PrazoPagamentoItensService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  public getByIdPrazoPagamento(id_prazo_pagamento: number): Observable<PrazoPagamentoItens[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_prazo_pagamento": id_prazo_pagamento
    };

    return this.http.post<PrazoPagamentoItens[]>(this.baseUrl + "api/PrazoPagamentoItens/GetByIdPrazoPagamento", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }
}
